export function getAllUrlParams(): Record<string, string> {
  if (typeof window === 'undefined') {
    return {}
  }

  const searchParams = new URLSearchParams(window.location.search)
  const params: Record<string, string> = {}

  searchParams.forEach((value, key) => {
    params[key] = value
  })

  return params
}

const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign']

export function getUtmParams(): Record<string, string> {
  const allParams = getAllUrlParams()
  const utmParams: Record<string, string> = {}

  UTM_PARAMS.forEach((key) => {
    if (allParams[key]) {
      utmParams[key] = allParams[key]
    }
  })

  return utmParams
}

export function buildUrlWithUtm(path: string): string {
  const utmParams = getUtmParams()
  const utmString = new URLSearchParams(utmParams).toString()

  if (!utmString) return path

  const separator = path.includes('?') ? '&' : '?'
  return `${path}${separator}${utmString}`
}
